var _defs, _rect, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncandescentLampLightbulb2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 0.25px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 16,
    height: 16
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 10.66,
    cy: 8,
    rx: 4.98,
    ry: 4.77
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,10.2H6.65c1.36.09,1.66.19,2-.1a1.36,1.36,0,0,0,.68-1.24c0-1-1.56-1.34-2-1.34s-.78-.19-.88.29-.1.76.68.57A2.8,2.8,0,0,0,8.5,7.9c.59-.47,1-.47.88-1.24A.73.73,0,0,0,8.5,6H8.41A5.54,5.54,0,0,0,6.74,5.9L0,5.71",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncandescentLampLightbulb2);
export default __webpack_public_path__ + "static/media/IncandescentLampLightbulb2.d20432ad1bdf432bd6380ddfe856495f.svg";
export { ForwardRef as ReactComponent };